<template>
  <v-flex xs12 class="py-0">
    <v-expansion-panels flat accordion class="licenses">
      <v-expansion-panel class="license-details px-0">
        <v-expansion-panel-header class="">
          <div class="py-0">{{ $t('licenses.licenseAuthorizationHeader') }}</div>
          <template #actions>
            <v-icon :color="$vuetify.theme.dark ? '#ffffff' : 'info'">
              $vuetify.icons.expand
            </v-icon>
          </template>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-expansion-panels flat accordion class="licenses pl-1">
            <v-expansion-panel class="license-details pl-0" expand-icon="arrow_drop_down">
              <v-expansion-panel-header>
                <div class="font-weight-bold1">{{ $t('licenses.coursesHeader') }}</div>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-card
                  v-if="license && license.apexCourses && license.apexCourses.length > 1"
                  flat
                  class="tab-card no-border"
                >
                  <v-card-title class="text-subtitle-1 py-1">{{
                    $t('licenses.apexCourses')
                  }}</v-card-title>
                  <v-card-text>
                    <ul>
                      <li
                        v-for="(course, i) in license.apexCourses"
                        :key="i"
                        class="permission_name"
                      >
                        <span v-if="course.authorized && isVisible(course)">{{ course.name }}</span>
                      </li>
                    </ul>
                  </v-card-text>
                </v-card>
                <v-card
                  v-if="license && license.connectCourses && license.connectCourses.length > 1"
                  flat
                  class="tab-card no-border"
                >
                  <v-card-title class="text-subtitle-1 py-1">{{
                    $t('licenses.connectCourses')
                  }}</v-card-title>
                  <v-card-text>
                    <ul>
                      <li
                        v-for="(course, i) in license.connectCourses"
                        :key="i"
                        class="permission_name"
                      >
                        <span v-if="course.authorized && isVisible(course)">{{ course.name }}</span>
                      </li>
                    </ul>
                  </v-card-text>
                </v-card>

                <!-- <v-card flat class="tab-card no-border">
                  <v-card-text>
                    <ul>
                      <li v-for="(course, i) in license.courses" :key="i" class="permission_name">
                        <span v-if="course.authorized && isVisible(course)">{{ course.name }}</span>
                      </li>
                    </ul>
                  </v-card-text>
                </v-card> -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-expansion-panels flat accordion class="licenses pl-1">
            <v-expansion-panel class="license-details pl-0" expand-icon="arrow_drop_down">
              <v-expansion-panel-header>
                <div class="font-weight-bold1">{{ $t('licenses.permissionsHeader') }}</div>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-card flat class="tab-card no-border">
                  <v-card-text>
                    <ul>
                      <li
                        v-for="(permission, i) in license.permissions"
                        :key="i"
                        class="permission_name"
                      >
                        <span
                          v-if="permission.authorized && isVisible(permission)"
                          :class="{
                            textBold: canViewAdmin && viewingAdmin && !permission.license_public,
                          }"
                          >{{ permission.name }}</span
                        >
                      </li>
                    </ul>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-expansion-panels flat accordion class="licenses pl-1">
            <v-expansion-panel class="license-details pl-0" expand-icon="arrow_drop_down">
              <v-expansion-panel-header>
                <div class="font-weight-bold1">{{ $t('licenses.trackingSystemsHeader') }}</div>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-card flat class="tab-card no-border">
                  <v-card-text>
                    <ul>
                      <li
                        v-for="(ts, i) in license.trackingSystems"
                        :key="i"
                        class="permission_name"
                      >
                        <span
                          v-if="ts.authorized && isVisible(ts)"
                          :class="{
                            textBold: canViewAdmin && viewingAdmin && !ts.license_public,
                          }"
                          >{{ ts.name }}</span
                        >
                      </li>
                    </ul>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-flex>
</template>

<script>
export default {
  name: 'LicenseItemAuthorizations',
  props: {
    license: {
      type: Object,
      required: true,
    },
    viewingAdmin: {
      type: Boolean,
      default: false,
    },
    canViewAdmin: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    isVisible(item) {
      if (this.viewingAdmin) return true;
      return item?.license_public;
    },
  },
};
</script>

<style scoped>
.licenses {
  box-shadow: none;
}

.tab-card {
  background-color: rgba(0, 0, 0, 0) !important;
  min-height: 60px;
}

ul {
  list-style: none;
  padding: 0;
  columns: 3;
  -webkit-columns: 3;
  -moz-columns: 3;
}

li.permission_name {
  text-indent: -8px;
  padding-left: 8px;
  word-wrap: normal;
}

.textBold {
  font-weight: bold;
}

* >>> .v-expansion-panel-header {
  min-height: 48px;
}

@media (max-width: 600px) {
  ul {
    columns: 2;
    -webkit-columns: 2;
    -moz-columns: 2;
  }
}

.license-details * >>> .v-expansion-panel-content__wrap {
  padding-left: 8px;
  padding-right: 8px;
}
</style>
